
import { useState, useEffect } from 'react'
import { Modal, Form, Input, notification, Select } from 'antd';
import axios from 'axios';
import axiosConfig from '../../configs/axios.config';

const UserDetail = (props) => {
    const [pages, setPages] = useState([])
    const {open, detailData, setOpen} = props
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [form] = Form.useForm()

    useEffect(() => {
        setIsModalOpen(open);
    },[open])
    const handleCancel = () => {
        setOpen(false);
    };

    const _getRole = () => {
        const response = axios.create(axiosConfig).get('/api/groupRoles')
        response
            .then((response) => {
                if(response.status !== 200 && !response.data) {
                    return notification.warning({
                        message: response.data.message || "Lỗi hệ thống",
                    })
                }
                const { list} = response.data.data
                setPages(list)
            })
            .catch((error) => {
                console.log(error);
                return notification.warning({
                    message: error || "Hệ thống đang bảo trì, vui lòng thử lại sau!",
                })
            })
    }
    const detailPermission =  () =>{
        if(detailData){
          const { USERID, U_NAME, groupRoleId } = detailData
          const dataform = {
            id: USERID,
            name: U_NAME,
            groupRoleId
          }
          form.setFieldsValue(dataform)
          
        }
    }
    let dataPermis = []
    useEffect(() => {
        _getRole()
    },[])
    const formatData = () => {
        pages?.length && pages.forEach((item, index) => {
            dataPermis[index] = {value: item.id, label: item.name}
        })
    }
    formatData()


    const onCreact = async () =>{
            await form.validateFields()
            const { id,groupRoleId } = form.getFieldValue() 
            
            const body = {
                id,
                groupRoleId,
            }
            const response = axios.create(axiosConfig).put('/api/updateUsers', body)
            response
              .then((response) => {
                if(response.status !== 200 && !response.data) {
                    return notification.warning({
                        message: response.data.message || 'cập nhật phân quyền thất bại vui lòng thử lại!',
                    })
                }
                notification.success({ message: response.data.message || "Thành công" })
              })
              .catch((error) => {
                  console.log(error);
                  return notification.warning({
                      message: error || 'Hệ thống đang bảo trì, vui lòng thử lại sau!',
                  })
              })
          setOpen(false);
    }
    useEffect(() => {
        detailPermission()
    },[detailData])
    return (
        <>
            <Modal 
                title={'Cập nhật quyền User'} 
                visible={isModalOpen} onOk={() => {onCreact();}} onCancel={handleCancel}
                width={'40vw'} style={{margin: '0 auto', }}>
            <div style={{display: 'flex', gap:"10px", }}>
            <Form style={{width: '100%'}} form={form} layout={'vertical'} 
            initialValues={{key:'EMPLOYEE'}}>
                <Form.Item
                    label="Tên người dùng"
                    name="name"
                    >
                    <Input disabled={true} style={{color: '#444444ad'}}/>
                </Form.Item>
                <Form.Item
                    label="Quyền người dùng"
                    name='groupRoleId'
                    >
                    <Select
                    style={{
                        width: '100%',
                    }}
                    options={dataPermis ? dataPermis : ''}
                    />
                </Form.Item>
                

            </Form>
            </div>
            </Modal>
        </>
      


    )

}

export default UserDetail